import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import { Button$ClickEvent } from "sap/ui/webc/main/Button";
import ColumnListItem from "sap/m/ColumnListItem";
import { EmailDto } from "../../models/EmailDto";

/**
 * @namespace akademika.akamont.pages.businessUnitDetails
 */
export default class BusinessUnitDetails extends BaseController {
  route = Routes.BUSINESS_UNIT_DETAILS;
  parentRoute = Routes.BUSINESS_UNIT_LIST;

  public async onRouteMatched() {
    this.setModel(new JSONModel({ edit: false }), "viewOptions");

    await this.refreshPageData();
  }

  public async refreshBusinessUnitDetails() {
    await this.fetchModel(
      "api/BusinessUnit/GetBusinessUnitDetails/" +
        this.routeParams.businessUnitId
    );

    const businessUnitEmails = this.getView()
      ?.getModel()
      ?.getProperty("/businessUnitEmails");
    const emailIds = businessUnitEmails.map(
      (e: { emailId: number }) => e.emailId
    );
    (this.getView()?.getModel() as JSONModel).setProperty(
      "/businessUnitEmailIds",
      emailIds
    );
  }

  public async getBusinessUnitOptions() {
    await this.fetchModel(
      "api/BusinessUnit/GetBusinessUnitSelectData",
      "businessUnitOptions"
    );
  }

  public async saveBusinessUnit() {
    const businessUnitDetails = this.getModel().getData();

    await this.saveDataAndShowMessage("api/BusinessUnit/EditBusinessUnit", {
      body: businessUnitDetails,
    });

    await this.refreshPageData();
    this.getModel("viewOptions").setProperty("/edit", false);
  }

  public onEditBusinessUnit() {
    this.getModel("viewOptions").setProperty("/edit", true);
  }

  public async onCancelEdit() {
    this.getModel("viewOptions").setProperty("/edit", false);
    await this.refreshPageData();
  }

  public addEmail() {
    const model = this.getModel() as JSONModel;
    const emailValue = model.getProperty("/newEmail");

    if (!emailValue) return;

    const emails = model.getProperty("/businessUnitEmails") as EmailDto[];
    const newEmailObject: EmailDto = {
      active: true,
      value: emailValue,
    };
    emails.push(newEmailObject);
    model.refresh();
    model.setProperty("/newEmail", "");
  }

  public onDeleteEmail(event: Button$ClickEvent) {
    const source = event.getSource().getParent() as ColumnListItem;
    const bindingPath = source.getBindingContext()?.getPath();
    const model = this.getModel() as JSONModel;
    if (bindingPath) {
      const item = model.getProperty(bindingPath);
      const allEmails = model.getProperty("/businessUnitEmails") as EmailDto[];
      const filteredEmails = allEmails.filter((e) => e.value != item.value);
      model.setProperty("/businessUnitEmails", filteredEmails);
    }
  }

  public async refreshPageData() {
    await this.getBusinessUnitOptions();
    await this.refreshBusinessUnitDetails();
  }
}
